import { BRANDS_FETCH, BRANDS_ADD, SAVE_CURRENT_CARD_BRAND } from '../constants/actionTypes';

const doFetchBrands = () => ({
  type: BRANDS_FETCH,
});

const doSaveBrands = brands => ({
  type: BRANDS_ADD,
  payload: brands,
});

const doSaveCurrentCardBrand = brand => ({
  type: SAVE_CURRENT_CARD_BRAND,
  payload: brand,
});

export { doFetchBrands, doSaveBrands, doSaveCurrentCardBrand };
